(() => {
  const closeMenus = (except) => document.querySelectorAll('[data-pulse-menu][open]').forEach(menu => { if (menu !== except) menu.open = false; });
  document.addEventListener('click', event => { if (!event.target.closest('[data-pulse-menu]')) closeMenus(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-pulse-menu][open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-pulse-menu]') && event.target.open) closeMenus(event.target);
  }, true);
})();
